import Image from '../../../atoms/Image';

interface IControlItemProps {
  disable: boolean;
  imageUrl: string;
  click(): void;
}

const ControlItem = ({ disable, imageUrl, click }: IControlItemProps) => {
  return (
    <div className={`control ${disable ? 'control--locked' : ''}`}>
      <Image src={imageUrl} size='s' onClick={disable ? undefined : click} />
    </div>
  );
};

export default ControlItem;
